import { useWindowsDimension } from '../../../hooks/useWindowsDimension';
import styles from './Header.module.css';
import { ReactComponent as MenuSvg } from "../../../assets/icons/menu.svg";
import { ReactComponent as CloseSvg } from "../../../assets/icons/close.svg";
import { HeaderMenuMobile } from './HeaderMenuMobile';
import { useMemo, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { useScrollPosition } from '../../../hooks/useScrollPosition';
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { LanguagePicker } from '../../common/components/LanguagePicker';
import { ReactComponent as LanguagesSvg } from "../../../assets/icons/languages.svg";

export const Header = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    const [isMenuOpen, setIsMenuOpen] = useState(false);    
    const { isMobile } = useWindowsDimension();
    const { isScrolled } = useScrollPosition(20);

    const handleMenuClick = () => {
        setIsMenuOpen(prevState => !prevState);
    }

    const handleMenuItemClick = () => {
        setIsMenuOpen(false);
    }

    const handleLogoClick = () => {
        if (location.pathname === "/") {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        } else {
            navigate("/");
        }
    };

    const isWhiteHeader = useMemo(() => {
        const whiteHeaderPaths = ["/"];
        return whiteHeaderPaths.includes(location.pathname) && !isScrolled;
    }, [location.pathname, isScrolled]);

    console.log('isWhiteHeader:', isWhiteHeader, 'pathname:', location.pathname, 'isScrolled:', isScrolled);
    
    return (
        <header className={styles.wrapper}>
            <div className={`${styles.container} ${isScrolled || isMobile ? styles.scrolled : styles.transparent}`}>
                <div className={styles.horizontalContainer}>
                    <img
                        src={require( !isWhiteHeader || isMobile ? "../../../assets/images/logo-black.png" : "../../../assets/images/logo-white.png")}
                        alt="Gluten Freends Logo"
                        className={styles.logoImage}
                        onClick={handleLogoClick}
                    />
                    {
                        !isMobile ? (
                            <div className={styles.headerLabelWrapper}>
                                {/** <section id="events"> */}
                                <NavLink
                                    to="/#events"
                                    onClick={handleMenuItemClick}
                                    className={({ isActive }) =>
                                        `${styles.headerLabel}
                                        ${!isWhiteHeader ? styles.headerLabelDark : ""}`
                                    }
                                >
                                    {t('header.tabs.events')}
                                </NavLink>

                                {/*
                                <NavLink
                                    to="/about"
                                    onClick={handleMenuItemClick}
                                    className={({ isActive }) =>
                                        `${styles.headerLabel}
                                        ${isDarkHeader ? styles.headerLabelDark : ""}
                                        ${isActive ? styles.headerLabelIsActive : ""}`
                                    }
                                >
                                    {t('header.tabs.about')}
                                </NavLink>
                                */}
                                <NavLink
                                    to="/contact"
                                    onClick={handleMenuItemClick}
                                    className={({ isActive }) =>
                                        `${styles.headerLabel}
                                        ${!isWhiteHeader ? styles.headerLabelDark : ""}
                                        ${isActive ? styles.headerLabelIsActive : ""}`
                                    }
                                >
                                    {t('header.tabs.contact')}
                                </NavLink>

                                <LanguagePicker
                                    trigger={({ currentLang, isOpen, toggle, ref }) => (
                                        <button 
                                            ref={ref} 
                                            className={`${styles.langSelector} ${!isWhiteHeader ? styles.langSelectorDark : ''}`} 
                                            onClick={toggle}
                                        >
                                            <LanguagesSvg width={20} height={20} style={{ fill: 'currentColor' }} />
                                            <span>{currentLang.label}</span>
                                            <span className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ''}`}>▾</span>
                                        </button>
                                    )}
                                />
                            </div>
                        ) : (
                            isMenuOpen ?
                                <CloseSvg height={24} width={24} onClick={handleMenuClick}/>
                                :
                                <MenuSvg height={24} width={24} onClick={handleMenuClick}/>
                        )
                    }
                </div>

                <AnimatePresence>
                    {isMenuOpen && <HeaderMenuMobile onClick={handleMenuItemClick} />}
                </AnimatePresence>
            </div>
        </header>
    )
}